$(function(){

	var body = $('body');

	// GSAP
	window.GreenSockGlobals ? body.addClass('gsap') : body.removeClass('gsap');

	var tween = {
		t1: '.hamburger__layer:first-child',
		t2: '.hamburger__layer:last-child',
		t3: '.hamburger__layer:nth-child(2)',
		t4: '.site-nav',
		t5: '.overlay',
		t6: '.post',
		speed: 0.5,
		ease: Power4.easeOut
	};

	var t1 = new TimelineLite();
	t1.to(tween.t1, tween.speed*0.5, { y:6, ease: tween.ease});
	t1.to(tween.t1, tween.speed*0.5, { rotation:45, ease: tween.ease});
	t1.pause();

	var t2 = new TimelineLite();
	t2.to(tween.t2, tween.speed*0.5, { y:-6, ease: tween.ease});
	t2.to(tween.t2, tween.speed*0.5, { rotation:-45, ease: tween.ease});
	t2.pause();

	var t3 = new TimelineLite();
	t3.to(tween.t3, tween.speed, { opacity:0, ease: tween.ease});
	t3.pause();

	var t4 = new TimelineLite();
	t4.to(tween.t4, tween.speed, { x:0, ease: tween.ease});
	t4.pause();

	var t5 = new TimelineLite();
	t5.to(tween.t5, tween.speed, { position: 'fixed', opacity: 0.7, ease: tween.ease});
	t5.pause();

	var t6 = new TimelineLite();
	t6.to(tween.t6, tween.speed, { opacity: 0, ease: tween.ease});
	t6.to(tween.t6, tween.speed, { opacity: 1, ease: tween.ease});


	// On Burger Click
	$('.hamburger').on('click', function(){

		if ( body.hasClass('drawer-open') ) {

			$('body').removeClass('drawer-open');

			t1.reverse();
			t2.reverse();
			t3.reverse();
			t4.reverse();
			t5.reverse();

		} else {

			$('body').addClass('drawer-open');

			t1.play();
			t2.play();
			t3.play();
			t4.play();
			t5.play();

		}
	})



	$('.site-nav').on('click', 'a', function(e){

		e.preventDefault();

		var path = $(this).attr('href');

		$('body').removeClass('drawer-open');

		t1.reverse();
		t2.reverse();
		t3.reverse();
		t4.reverse();
		t5.reverse();
		t6.reverse();

		setInterval(function(){
			location.pathname = path;
		}, 600)

	})
})




//////////////////
// WEBPACK FOOTER
// ./_src/js/main.js
// module id = 13
// module chunks = 0